<!-- 简易tip组件 -->
<template>
  <div
    class="com-tip v-popper--usearrow"
    :class="extClass"
    :x-placement="placement"
    :style="`z-index:${zIndex};${postionStyle}`"
  >
    <span class="v-popper__arrow" :style="arrowStyle"></span>
    <div class="v-popper__content"><slot></slot></div>
  </div>
</template>

<script>
export default {
  props: {
    // 相对位置
    placement: {
      default: 'top',
    },
    // 额外class
    clazz: {
      default: '',
    },
    // zindex值
    zIndex: {
      default: 200,
    },
    // 是否跟随页面滚动。默认不跟随，页面滚动时会隐藏
    // 如果不能对页面进行精准控制，简易移除。
    isFlowPageScroll: {
      default: false,
    },
  },
  data() {
    return {
      // 计算tip位置的定位元素，必须
      refer: null,
      // 弹框样式
      postionStyle: '',
      // 箭头位置
      arrowStyle: '',
      // 是否处于隐藏状态
      isHidden: true,
    };
  },
  computed: {
    extClass() {
      return `${this.clazz} ${this.isHidden ? 'is-hidden' : ''}`;
    },
  },
  mounted() {
    try {
      document.body.appendChild(this.$el);
    } catch (ex) {
      console.warn('append tip Fail!');
    }

    if (this.isFlowPageScroll) {
      // 页面滚动时重新计算位置
      document.addEventListener('scroll', this.computePosition, true);
    } else {
      // 页面滚动时，隐藏掉，否则会超出界面，很难看
      document.addEventListener('scroll', this.checkIfHideWhenScroll, true);
    }
  },
  destroyed() {
    if (this.isFlowPageScroll) {
      document.removeEventListener('scroll', this.computePosition, true);
    } else {
      document.removeEventListener('scroll', this.checkIfHideWhenScroll, true);
    }
  },
  methods: {
    show(refer) {
      this.refer = refer;
      if (!this.refer) {
        return;
      }

      // 先执行一次运算
      // 否则tip的定位会有问题
      this.computePosition();
      this.$nextTick(() => {
        this.isHidden = false;
        this.computePosition();
      });
    },
    hide() {
      this.isHidden = true;
    },

    /**
     * 滚动时检测是否需要隐藏tip
     * 因为滚动时捕获方式监听的，所以如果tip内元素滚动到话，也会导致触发。所以要排除一下
     * @param {Event} e
     */
    checkIfHideWhenScroll(e) {
      // 只有当触发滚动事件的元素不属于tip内部时才隐藏
      const { target } = e;
      if (!this.$el.contains(target)) {
        this.hide();
      }
    },

    // 计算位置
    computePosition() {
      const pos = this?.refer?.getBoundingClientRect() || null;
      if (!pos) {
        console.warn('dom position error!');
        return;
      }

      const { width: myWidth, height: myHeight } = this.$el.getBoundingClientRect();

      const { left, top, right, bottom, width, height } = pos;

      const arrowHalfSize = 12 / 2;

      let myLeft = 0;
      let myTop = 0;

      let arrowLeft = 0;
      let arrowTop = 0;

      switch (this.placement) {
        case 'top':
          myTop = top - myHeight - arrowHalfSize;
          myLeft = left + width / 2 - myWidth / 2;
          arrowLeft = myWidth / 2;
          this.postionStyle = `left:${myLeft}px; top:${myTop}px;`;
          this.arrowStyle = `left: ${arrowLeft}px`;
          break;
        case 'top-start':
          myTop = top - myHeight - arrowHalfSize;
          myLeft = left;
          arrowLeft = Math.min(
            width / 2,
            myWidth / 2,
          );
          this.postionStyle = `left:${myLeft}px; top:${myTop}px;`;
          this.arrowStyle = `left: ${arrowLeft}px`;
          break;
        case 'top-end':
          myTop = top - myHeight - arrowHalfSize;
          myLeft = right - myWidth;
          arrowLeft = myWidth - Math.min(
            width / 2,
            myWidth / 2,
          );
          this.postionStyle = `left:${myLeft}px; top:${myTop}px;`;
          this.arrowStyle = `left: ${arrowLeft}px`;
          break;

        case 'bottom':
          myTop = top + height + arrowHalfSize;
          myLeft = left + width / 2 - myWidth / 2;
          arrowLeft = myWidth / 2;
          this.postionStyle = `left:${myLeft}px; top:${myTop}px;`;
          this.arrowStyle = `left: ${arrowLeft}px`;
          break;
        case 'bottom-start':
          myTop = top + height + arrowHalfSize;
          myLeft = left;
          arrowLeft = Math.min(
            width / 2,
            myWidth / 2,
          );
          this.postionStyle = `left:${myLeft}px; top:${myTop}px;`;
          this.arrowStyle = `left: ${arrowLeft}px`;
          break;
        case 'bottom-end':
          myTop = top + height + arrowHalfSize;
          myLeft = right - myWidth;
          arrowLeft = myWidth - Math.min(
            width / 2,
            myWidth / 2,
          );
          this.postionStyle = `left:${myLeft}px; top:${myTop}px;`;
          this.arrowStyle = `left: ${arrowLeft}px`;
          break;

        case 'left':
          myLeft = left - myWidth - arrowHalfSize;
          myTop = top + height / 2 - myHeight / 2;
          arrowTop = myHeight / 2;
          this.postionStyle = `left:${myLeft}px; top:${myTop}px;`;
          this.arrowStyle = `top: ${arrowTop}px`;
          break;
        case 'left-start':
          myLeft = left - myWidth - arrowHalfSize;
          myTop = top;
          arrowTop = Math.min(
            height / 2,
            myHeight / 2,
          );
          this.postionStyle = `left:${myLeft}px; top:${myTop}px;`;
          this.arrowStyle = `top: ${arrowTop}px`;
          break;
        case 'left-end':
          myLeft = left - myWidth - arrowHalfSize;
          myTop = bottom - myHeight;
          arrowTop = myHeight - Math.min(
            height / 2,
            myHeight / 2,
          );
          this.postionStyle = `left:${myLeft}px; top:${myTop}px;`;
          this.arrowStyle = `top: ${arrowTop}px`;
          break;

        case 'right':
          myLeft = left + width + arrowHalfSize;
          myTop = top + height / 2 - myHeight / 2;
          arrowTop = myHeight / 2;
          this.postionStyle = `left:${myLeft}px; top:${myTop}px;`;
          this.arrowStyle = `top: ${arrowTop}px`;
          break;
        case 'right-start':
          myLeft = left + width + arrowHalfSize;
          myTop = top;
          arrowTop = Math.min(
            height / 2,
            myHeight / 2,
          );
          this.postionStyle = `left:${myLeft}px; top:${myTop}px;`;
          this.arrowStyle = `top: ${arrowTop}px`;
          break;
        case 'right-end':
          myLeft = left + width + arrowHalfSize;
          myTop = bottom - myHeight;
          arrowTop = myHeight -  Math.min(
            height / 2,
            myHeight / 2,
          );
          this.postionStyle = `left:${myLeft}px; top:${myTop}px;`;
          this.arrowStyle = `top: ${arrowTop}px`;
          break;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.com-tip {
  max-width: 60%;
  &.v-popper--usearrow {
    position: absolute;
    z-index: 200;
    visibility: visible;
    display: flex;
    justify-content: center;
    outline: 0;
    padding: 8px;
    font-size: 12px;
    line-height: 16px;
    color: rgba(0, 1, 10, 0.93);
    background: #fff;
    border: 0.5px solid;
    border-color: rgba(17, 32, 70, 0.13);
    border-radius: 3px;
    box-shadow: 0px 0px 1px 0px rgba(18, 19, 25, 0.08),
      0px 0px 4px 0px rgba(18, 19, 25, 0.08),
      0px 6px 12px 0px rgba(18, 19, 25, 0.12);
    min-width: 36px;
    box-sizing: border-box;

    &.is-hidden {
      top: 0 !important;
      left: -9999px !important;
      visibility: hidden;
    }

    .v-popper__arrow {
      overflow: hidden;
      position: absolute;
      width: 0;
      height: 0;
      font-size: 0;
      line-height: 0;

      &:before {
        opacity: 0.5;
        content: "";
        position: absolute;
        border: 6px solid;
        border-color: rgba(17,32,70,.13);
      }

      &:after {
        content: "";
        position: absolute;
        border: 6px solid;
        border-color: #fff;
      }
    }

    &[x-placement^="top"] .v-popper__arrow,
    &[x-placement^="bottom"] .v-popper__arrow {
      border-left-color: transparent;
      border-right-color: transparent;
      transform: translateX(-50%);
      width: 12px;
      height: 7px;
    }

    &[x-placement^="left"] .v-popper__arrow,
    &[x-placement^="right"] .v-popper__arrow {
      border-top-color: transparent;
      border-bottom-color: transparent;
      transform: translateY(-50%);
      width: 7px;
      height: 12px;
    }

    &[x-placement^="top"] .v-popper__arrow {
      border-bottom-color: transparent;
      bottom: -6px;

      &:before {
        bottom: -6px;
        border-bottom-color: transparent;
        border-right-color: transparent;
        border-left-color: transparent;
      }

      &:after {
        bottom: -5px;
        border-bottom-color: transparent;
        border-right-color: transparent;
        border-left-color: transparent;
      }
    }

    &[x-placement^="bottom"] .v-popper__arrow {
      border-top-color: transparent;
      top: -6px;

      &:before {
        top: -6px;
        border-top-color: transparent;
        border-right-color: transparent;
        border-left-color: transparent;
      }

      &:after {
        top: -5px;
        border-top-color: transparent;
        border-right-color: transparent;
        border-left-color: transparent;
      }
    }

    &[x-placement^="left"] .v-popper__arrow {
      border-right-color: transparent;
      right: -6px;

      &:before {
        right: -6px;
        border-right-color: transparent;
        border-bottom-color: transparent;
        border-top-color: transparent;
      }

      &:after {
        right: -5px;
        border-right-color: transparent;
        border-bottom-color: transparent;
        border-top-color: transparent;
      }
    }

    &[x-placement^="right"] .v-popper__arrow {
      border-left-color: transparent;
      left: -6px;

      &:before {
        left: -6px;
        border-left-color: transparent;
        border-bottom-color: transparent;
        border-top-color: transparent;
      }

      &:after {
        left: -5px;
        border-left-color: transparent;
        border-bottom-color: transparent;
        border-top-color: transparent;
      }
    }
  }
}
</style>
